{
  "notifications": {
    "errors": {
      "delete_failed": "Failed to delete Shipping Method \"{name}\"."
    },
    "success": {
      "delete_succeeded": "Shipping Method \"{name}\" successfully deleted."
    }
  }
}
